"use strict";
/**
 * productManageMentAppExternalSysModule Module
 *
 * Description 外联模块管理
 * Author:fanglijuan 2016-11-04
 */
angular.module('productManageMentAppExternalSysModule', []).
controller('productManageMentAppExternalSysController', ['$scope', '$q', '$state', '$stateParams', '$modal', 'trsHttpService', 'modalDialog', 'trsspliceString', 'productMangageMentAppService', 'editingCenterService',
    function($scope, $q, $state, $stateParams, $modal, trsHttpService, modalDialog, trsspliceString, productMangageMentAppService, editingCenterService) {
        initStatus();
        initData();
        /**
         * [initStatus description]初始化状态
         */
        function initStatus() {
            $scope.data = {
                items: [],
                selectedArray: [],
                copyCurrPage: 1,
                siteMsg: "",
            };
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "ITEMCOUNT": 0,
            };
            getTemplateRights();//按钮权限
        }
        /**
         * [getTemplateRights 获取外联模块按钮权限]
         * @return {[type]} [description]
         */
        function getTemplateRights() {
            productMangageMentAppService.getRight($stateParams.site, "", "appsetsite.communications").then(function(data) {
                $scope.status.right = data;
            });
        }
        /**
         * [selectAll description:全选]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
            cancelBatchOperate();
        };

        /**
         * [selectDoc 单选]
         * @param  {[type]} item [description：单个对象] 
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
            cancelBatchOperate();
        };
        /**
         * [cancelBatchOperate description：取消批量操作的样式]
         */
        function cancelBatchOperate() {
            if ($scope.data.selectedArray.length === 0) {
                $scope.status.batchOperateBtn = {
                    "hoverStatus": "",
                    "clickStatus": ""
                };
            }
        }

        /**
         * [initData description]初始化数据
         */
        function initData() {
            requestData();
            editingCenterService.getSiteInfo($stateParams.site).then(function(data) {
                $scope.data.siteMsg = data;
            });
        }
        //下一页
        $scope.pageChanged = function() {
            $scope.data.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        //跳转指定页面
        $scope.jumpToPage = function() {
            if ($scope.data.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.data.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.data.copyCurrPage;
            requestData();
        };
        /**
         * [requestData description:数据请求方法]
         */
        function requestData() {
            var defer = $q.defer();
            var params = {
                serviceid: "mlf_appconfig",
                methodname: "queryExtSysBySite",
                CurrPage: $scope.page.CURRPAGE,
                pagesize: $scope.page.PAGESIZE,
                SITEID: $stateParams.site,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                $scope.data.items = data.DATA;
                $scope.page = data.PAGER;
                $scope.data.selectedArray = [];
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [add description 新增弹窗]
         */
        $scope.add = function() {
            productMangageMentAppService.newAndModifyExternalSys("", $stateParams.site, function(data) {}).then(function(data) {
                requestData();
            }, function(data) {
                //失败
            });
        };
        /**
         * [add description 修改弹窗]
         */
        $scope.modifyConfig = function(item) {
            productMangageMentAppService.newAndModifyExternalSys(item, $stateParams.site, function(data) {}).then(function(data) {
                requestData();
            }, function(data) {
                //失败
            });
        };

        /**
         * [deleteGroup description]单个删除
         */
        $scope.deleteConfig = function(item) {
            modalDialog.confirmModal("删除外链配置", "是否确认删除该外链配置", function() {
                var params = {
                    serviceid: "mlf_appconfig",
                    methodname: "delExternalSys",
                    EXTERNALSYSTEMIDS: item.EXTERNALSYSTEMID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    modalDialog.alertType("删除成功", "", "success", false, function() {
                        requestData();
                    });
                });
            });
        };
        /**
         * [deleteConfig description 勾选（单个）多个删除]
         * @return {[type]} [description]
         */
        $scope.deleteConfigs = function() {
            modalDialog.confirmModal("删除外链配置", "是否确认删除选中的外链配置", function() {
                var params = {
                    serviceid: "mlf_appconfig",
                    methodname: "delExternalSys",
                    EXTERNALSYSTEMIDS: trsspliceString.spliceString($scope.data.selectedArray, "EXTERNALSYSTEMID", ","),
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    modalDialog.alertType("删除成功", "", "success", false, function() {
                        requestData();
                    });
                });
            });
        };
        /**
         * [positionToChannel description]定位到栏目
         * @return null [description]
         */
        $scope.positionToSite = function(siteMsg) {
            $state.go("manageconfig.productmanage.app.channel", { site: siteMsg.SITEID }, { reload: true });
        };
    }
]);
